export default "static/media/decor1.9227515.svg"